(function () {
  const animeApi = window.anime;

  if (!animeApi || typeof animeApi.animate !== 'function') return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animatedAttribute = 'data-biji-animated';

  function reveal(targets, options = {}) {
    const elements = Array.from(targets).filter((element) => !element.hasAttribute(animatedAttribute));

    if (!elements.length) return;

    elements.forEach((element) => element.setAttribute(animatedAttribute, 'true'));

    if (prefersReducedMotion.matches) return;

    animeApi.animate(elements, {
      opacity: { from: 0 },
      y: { from: options.y ?? 16 },
      duration: options.duration ?? 700,
      delay: animeApi.stagger(options.stagger ?? 90),
      ease: options.ease ?? 'outExpo',
    });
  }

  function animatePasswordPage() {
    if (!document.body.classList.contains('password')) return;

    reveal(document.querySelectorAll('.header__heading-link'), {
      y: -12,
      duration: 650,
      stagger: 120,
    });

    reveal(document.querySelectorAll('.password-main > .shopify-section, .password-main .shopify-block'), {
      y: 20,
      duration: 800,
      stagger: 120,
    });

    document.querySelectorAll('.header-password-login details').forEach((details) => {
      if (details.dataset.bijiMotionReady === 'true') return;

      details.dataset.bijiMotionReady = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open || prefersReducedMotion.matches) return;

        const content = details.querySelector('.password-modal__content');
        if (!content) return;

        animeApi.animate(content, {
          opacity: { from: 0 },
          scale: { from: 0.985 },
          duration: 420,
          ease: 'outExpo',
        });
      });
    });
  }

  function initializeSignupSwitchers() {
    document.querySelectorAll('[data-biji-signup-switcher]').forEach((switcher) => {
      if (switcher.dataset.bijiSwitcherReady === 'true') return;

      const tabs = Array.from(switcher.querySelectorAll('[data-biji-signup-tab]'));
      const panels = Array.from(switcher.querySelectorAll('[data-biji-signup-panel]'));

      if (tabs.length < 2 || panels.length < 2) return;

      function activate(type, focusTab = false) {
        const activeTab = tabs.find((tab) => tab.dataset.bijiSignupTab === type);
        const activePanel = panels.find((panel) => panel.dataset.bijiSignupPanel === type);

        if (!activeTab || !activePanel || activeTab.getAttribute('aria-selected') === 'true') return;

        tabs.forEach((tab) => {
          const selected = tab === activeTab;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel !== activePanel;
          panel.classList.toggle('is-active', panel === activePanel);
        });

        if (focusTab) activeTab.focus();

        if (!prefersReducedMotion.matches) {
          animeApi.animate(activePanel, {
            opacity: { from: 0 },
            y: { from: 12 },
            duration: 480,
            ease: 'outExpo',
          });
        }
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.bijiSignupTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
          activate(nextTab.dataset.bijiSignupTab, true);
        });
      });

      switcher.dataset.bijiSwitcherReady = 'true';
    });
  }

  function initializeShopifyFormTypography() {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      if (host.dataset.bijiTypographyWatch === 'true') return;

      host.dataset.bijiTypographyWatch = 'true';

      function applyTypography(attempt = 0) {
        const shadowRoot = host.shadowRoot;

        if (!shadowRoot) {
          if (attempt < 20) window.setTimeout(() => applyTypography(attempt + 1), 100);
          return;
        }

        if (shadowRoot.querySelector('[data-biji-form-typography]')) return;

        const style = document.createElement('style');
        style.dataset.bijiFormTypography = 'true';
        style.textContent = `
          *, *::before, *::after {
            font-family: 'TeX Gyre Heros Condensed', 'Arial Narrow', Arial, sans-serif !important;
            font-weight: 400 !important;
            text-transform: uppercase !important;
            border-radius: 0 !important;
          }

          h1, h2, h3, h4, h5, h6, p, label, a, legend {
            color: #f90b0b !important;
          }

          input, select, textarea, button {
            border-color: #f90b0b !important;
            background: #f90b0b !important;
            color: #000 !important;
          }

          label {
            color: #000 !important;
          }

          [class*='_formHeader_'] {
            display: none !important;
          }

          [class*='_formPhoneInputContainer_'] {
            display: grid !important;
            grid-template-columns: 8.4rem minmax(0, 1fr) !important;
            gap: 0.8rem !important;
            align-items: stretch !important;
          }

          .phone-country-selector,
          .phone-country-selector [class*='_selectContainer_'],
          .phone-country-selector [class*='_selectToggle_'] {
            width: 8.4rem !important;
            min-width: 8.4rem !important;
          }

          .phone-country-selector {
            display: flex !important;
            align-self: stretch !important;
            height: auto !important;
          }

          .phone-country-selector [class*='_selectContainer_'],
          .phone-country-selector [class*='_selectToggle_'] {
            display: flex !important;
            flex: 1 1 auto !important;
            align-self: stretch !important;
            height: auto !important;
          }

          .phone-country-selector [class*='_selectToggle_'] {
            height: 100% !important;
            min-height: 100% !important;
            max-height: none !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 0.8rem !important;
            padding: 0 1rem !important;
            border: 1px solid #f90b0b !important;
            background: #f90b0b !important;
            color: #000 !important;
          }

          .phone-country-selector [class*='_flagIcon_'] {
            display: block !important;
            width: 3rem !important;
            height: 2rem !important;
            object-fit: cover !important;
          }

          .phone-country-selector [class*='_arrowDownIcon_'] {
            display: flex !important;
            align-items: center !important;
          }

          .phone-country-selector [class*='_arrowDownIcon_'] path {
            fill: #000 !important;
          }

          input::placeholder, textarea::placeholder {
            color: rgba(0, 0, 0, 0.6) !important;
            opacity: 1 !important;
          }
        `;
        shadowRoot.append(style);
      }

      applyTypography();
    });
  }

  function initializeCountdowns() {
    document.querySelectorAll('[data-biji-countdown]').forEach((countdown) => {
      if (countdown.dataset.bijiCountdownReady === 'true') return;

      const endTime = Date.parse(countdown.dataset.countdownEnd);
      if (Number.isNaN(endTime)) return;

      const fields = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]'),
      };

      function updateCountdown() {
        const remaining = Math.max(0, endTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };

        Object.entries(values).forEach(([name, value]) => {
          if (fields[name]) fields[name].textContent = String(value).padStart(2, '0');
        });

        countdown.setAttribute(
          'aria-label',
          `${values.days} days, ${values.hours} hours, ${values.minutes} minutes, ${values.seconds} seconds until launch`
        );

        if (remaining === 0) window.clearInterval(countdown.timerId);
      }

      countdown.dataset.bijiCountdownReady = 'true';
      updateCountdown();
      countdown.timerId = window.setInterval(updateCountdown, 1000);
    });
  }

  function initializeMarquees() {
    document.querySelectorAll('[data-biji-marquee]').forEach((marquee) => {
      if (marquee.dataset.bijiMarqueeReady === 'true') return;

      const track = marquee.querySelector('[data-biji-marquee-track]');
      const group = marquee.querySelector('[data-biji-marquee-group]');
      if (!track || !group) return;

      marquee.dataset.bijiMarqueeReady = 'true';
      if (prefersReducedMotion.matches) return;

      const startMarquee = () => {
        const distance = group.getBoundingClientRect().width;
        if (!distance) return;

        animeApi.animate(track, {
          x: -distance,
          duration: Math.max(12000, distance * 18),
          loop: true,
          ease: 'linear',
        });
      };

      if (document.fonts?.ready) {
        document.fonts.ready.then(startMarquee);
      } else {
        startMarquee();
      }
    });
  }

  function initializeTourModals() {
    document.querySelectorAll('[data-biji-tour-modal]').forEach((details) => {
      if (details.dataset.bijiTourReady === 'true') return;

      const dialog = details.querySelector('.biji-tour__dialog');
      const closeButton = details.querySelector('[data-biji-tour-close]');
      const overlay = details.querySelector('[data-biji-tour-overlay]');

      function loadBandsintownWidget() {
        const initializer = details.querySelector('.bit-widget-initializer');
        if (!initializer || initializer.dataset.bijiWidgetRequested === 'true') return;

        initializer.dataset.bijiWidgetRequested = 'true';

        const script = document.createElement('script');
        script.src = 'https://widgetv3.bandsintown.com/main.min.js';
        script.charset = 'utf-8';
        script.async = true;
        script.dataset.bijiBandsintown = 'true';
        document.head.append(script);
      }

      function closeTourModal() {
        details.removeAttribute('open');
        document.body.classList.remove('biji-tour-open');
        details.querySelector('summary')?.focus();
      }

      details.addEventListener('toggle', () => {
        document.body.classList.toggle('biji-tour-open', details.open);
        if (!details.open || !dialog) return;

        loadBandsintownWidget();
        if (prefersReducedMotion.matches) return;

        animeApi.animate(dialog, {
          opacity: { from: 0 },
          scale: { from: 0.98 },
          duration: 420,
          ease: 'outExpo',
        });
      });

      closeButton?.addEventListener('click', closeTourModal);
      overlay?.addEventListener('click', (event) => {
        if (event.target === overlay) closeTourModal();
      });
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeTourModal();
      });

      details.dataset.bijiTourReady = 'true';
    });
  }

  function initialize() {
    animatePasswordPage();
    initializeSignupSwitchers();
    initializeShopifyFormTypography();
    initializeCountdowns();
    initializeMarquees();
    initializeTourModals();
    reveal(document.querySelectorAll('[data-biji-animate]'));
  }

  window.BijiAnimations = Object.freeze({
    animate: animeApi.animate,
    createTimeline: animeApi.createTimeline,
    stagger: animeApi.stagger,
    reveal,
    refresh: initialize,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);

  const appBlockObserver = new MutationObserver((mutations) => {
    const hasNewAppBlock = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) => node.nodeType === Node.ELEMENT_NODE && (node.matches?.('.shopify-block') || node.querySelector?.('.shopify-block'))
      )
    );

    if (hasNewAppBlock) animatePasswordPage();
    initializeShopifyFormTypography();
  });

  appBlockObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
